import React from 'react';

import { Badge } from 'antd';
import PropTypes from 'prop-types';

const { Ribbon } = Badge;

export default function ConditionalSoldOutRibbon({ isSoldOut, children }) {
  return isSoldOut ? (
    <ConditionalSoldOutRibbon.Wrapper>{children}</ConditionalSoldOutRibbon.Wrapper>
  ) : (
    children
  );
}

ConditionalSoldOutRibbon.propTypes = {
  isSoldOut: PropTypes.bool,
  children: PropTypes.node,
};

ConditionalSoldOutRibbon.Wrapper = function Wrapper({ children }) {
  return (
    <Ribbon className="checkout-main-item__sold-out-ribbon" text="Sold Out">
      {children}
    </Ribbon>
  );
};

ConditionalSoldOutRibbon.Wrapper.propTypes = {
  children: PropTypes.node,
};
